import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";

import { API_BASE_URL, base_url, profileImgSrc } from "../../../../config";
import { getAdminAuthToken } from "../../../../auth/auth";

import Loader from "../../../../components/Loader";
import deleteIcon from "../../../../assets/delete-icon-candidate.svg";
import commentIcon from "../../../../assets/comment-icon.svg";

export default function AddCandidate({ candidates, loadingJob }) {
  const [isLoading, setIsLoading] = useState(loadingJob);
  const [isDeleting, setIsDeleting] = useState(false);
  const [list, setList] = useState(candidates);
  const param = useParams();
  const token = getAdminAuthToken();

  useEffect(() => {
    setIsLoading(loadingJob);
  }, [loadingJob]);

  useEffect(() => {
    setList(candidates || []);
  }, [candidates]);

  const handleRemoveCandidate = async (id) => {
    const data = {
      job_id: param.id,
      employee_id: id,
    };

    try {
      setIsDeleting(true);
      const response = await fetch(
        `${API_BASE_URL}/admin/jobs/remove-candidate`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();
      setList((prev) => prev.filter((curr) => curr.id !== id));
      toast.success("Candidate removed!");
      setIsDeleting(false);
    } catch (error) {
      toast.error("Failed to delete candidate");
      return {
        error: "Failed to delete candidate",
      };
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="add-candidate-dashboard">
        {Object.keys(param).length !== 0 ? (
          <Link
            className="btn-all-white"
            to={`/admin/jobs/select-candidates/${param.id}`}
          >
            Add Candidate
          </Link>
        ) : (
          <button disabled className="btn-all-white">
            Create job to add candidates
          </button>
        )}

        <div className="candidates-wrapper">
          {isLoading ? (
            <Loader />
          ) : list.length === 0 ? (
            <p className="no-candidates">No Candidates</p>
          ) : (
            list?.map((c) => (
              <div
                key={c.id}
                className={`candidate-card ${
                  isDeleting ? "blink-disabled" : ""
                }`}
              >
                <div className="candidate-info">
                  <img
                    src={
                      c.avatar === null
                        ? profileImgSrc
                        : `${base_url}${c.avatar}`
                    }
                    alt={c.name}
                  />
                  <div>
                    <p className="name">{c.name}</p>
                    <p className="email">{c.email}</p>
                  </div>
                </div>

                <div className="candidate-buttons">
                  <div className="candidate-actions">
                    {c.status === 1 && (
                      <button className="btn-action dark" disabled>
                        Hired
                      </button>
                    )}

                    <Link
                      to={`/admin/proffesional-profile/${c.id}/edit`}
                      className="btn-icon"
                    >
                      <img src={commentIcon} alt="profile" />
                    </Link>
                    <button
                      className="btn-icon"
                      onClick={() => handleRemoveCandidate(c.id)}
                    >
                      <img src={deleteIcon} alt="delete" />
                    </button>
                  </div>

                  <div className="candidate-tags">
                    <button className="badge-chat">View Chat</button>
                    {c.status === 2 && (
                      <button className="badge-reject">
                        Rejected
                        {c.rejection_message !== null && (
                          <div className="rejection-message">
                            {c.rejection_message}
                          </div>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
